import { useEffect, useState } from "react";

export const useIsMobile = (minWidth?: number) => {
  const [isMobile, setIsMobile] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    let checkWidth = minWidth ?? 900;
    if (window.innerWidth < checkWidth) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
  }, []);

  return {
    isMobile,
    windowWidth,
  };
};
